import * as React from 'react';
import { useQuery } from 'react-query';
import api from '../../../Api';

type TitleConversationStatusesType = {
	conversationType: string;
	conversationId: string;
	communityId: number;
	status: string;
};

type UseTitleConversationStatusesType = {
	refetch: () => void;
	data: TitleConversationStatusesType[];
	isLoading: boolean;
};

const useTitleConversationStatuses = (
	communityId: number,
	skus: string[],
	cacheKey: string,
): UseTitleConversationStatusesType => {
	const { data, refetch, isLoading } = useQuery(cacheKey, fetchConvoStatuses);

	React.useEffect(() => {
		refetch();
	}, [skus.length]);

	function fetchConvoStatuses():
		| Promise<TitleConversationStatusesType[]>
		| [] {
		if (!skus.length) return [];
		return api.post(`/api/v1/conversations/${communityId}/titles`, skus);
	}

	return {
		data: data ?? [],
		refetch,
		isLoading,
	};
};

export default useTitleConversationStatuses;
